import './styles.scoped.css'
import {Pagination, TablePagination} from '@mui/material'

export default ({page, setPage, pageSize, setPageSize, rowCount}) => {
    return (
        <div className="container">
            <Pagination
                color="primary"
                count={Math.ceil(rowCount / pageSize)}
                page={page + 1}
                onChange={(event, value) => {
                    setPage(value - 1)
                }}
                showFirstButton
                showLastButton
            />
            <TablePagination
                component="div"
                rowsPerPage={pageSize}
                onRowsPerPageChange={e => setPageSize(e.target.value)}
                rowsPerPageOptions={[10, 20, 50]}
                labelDisplayedRows={() => ''}
                ActionsComponent={() => null}
                slotProps={{
                    select: {
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                        },
                    },
                }}
            />
        </div>
    )
}
